<div
  class="min-h-screen min-w-[100vw] flex items-center justify-center bg-primary-100"
>
    <div class="container">
     <div class="card w-full">
        <p-stepper  [value]="1" class="basis-[50rem]">
          <p-step-list>
            <p-step [value]="1">Instrucciones</p-step>
            <p-step [value]="2">Confirmación de datos</p-step>
            <p-step [value]="3">Contrato y firma</p-step>
        </p-step-list> 
        <p-step-panels>
          <p-step-panel [value]="1">
              <ng-template #content let-activateCallback="activateCallback">
                <div class="flex flex-col">
                  <h2 class="my-4 text-xl font-bold">
                    Vamos a firmar digitalmente tu contrato,
                    {{ op()?.seller?.name }}
                  </h2>
                  <ul class="list-none flex-col gap-2 pl-3">
                    <li class="mb-2">
                      <i class="ri-search-eye-line mr-4"></i> Revisa que todos los
                      datos sean correctos.<span class="font-semibold"> Si algún campo no se ajusta
                      correctamente comunícaselo a tu asesora de Luxoro antes de
                      firmar</span>
                    </li>
                    <li class="mb-2">
                      <i class="ri-sketching mr-4"></i> Firma digitalmente la
                      operación. Deberás realizar tu firma tal y como aparezca en
                      el DNI
                    </li>
                    <li>
                      <i class="ri-contract-line mr-4"></i> Cuando realices la
                      firma automáticamente se descargará tu contrato. No te
                      preocupes si no lo guardas o lo pierdes puesto que
                      recibirás una copia por correo electrónico
                    </li>
                  </ul>
                </div>
                <div class="flex pt-6 justify-end">
                  <p-button
                    label="Revisar datos"
                    iconPos="right"
                    (onClick)="activateCallback(2)"
                  />
                </div>
              </ng-template>
          </p-step-panel>
          <p-step-panel [value]="2">
              <ng-template #content let-activateCallback="activateCallback">
                <div class="flex flex-col gap-2 text-sm">
                  <div
                    class="border-2 border-dashed border-surface rounded-border bg-surface-50 dark:bg-surface-50 flex-col p-2 items-center font-medium"
                  >
                    <div class="font-bold">Datos personales</div>
                    <ul class="list-none">
                      <li>
                        {{ op()?.seller?.name }} {{ op()?.seller?.lastname }},
                        {{ op()?.seller?.dni?.number }}
                      </li>
                      <li>{{ op()?.seller?.email }}</li>
                      <li>
                        {{ op()?.seller?.address?.address }},
                        {{ op()?.seller?.address?.number }} ({{
                          op()?.seller?.address?.cp
                        }}) {{ op()?.seller?.address?.city?.localidad }}
                      </li>
                    </ul>
                  </div>
                  <div
                    class="border-2 border-dashed border-surface rounded-border bg-surface-50 dark:bg-surface-50 flex-col p-2 items-center font-medium"
                  >
                    <p class="font-bold">Datos de la venta</p>
                    <div>
                      Precio acordado:
                      {{ (op()?.tentative?.clientOffer ?? 0) + (op()?.tentative?.commercialEffort ?? 0) | currency : "EUR" }}
                    </div>
                    <div>
                      Método de abono: @if (op()?.transaction?.paymentMethod ===
                      'cash') { Efectivo } @else { Transferencia bancaria }
                    </div>
                    @if (op()?.transaction?.paymentMethod !== 'cash') {
                    <div class="mb-2">
                      Cuenta de cobro: {{ op()?.transaction?.paymentDetails }}
                    </div>
                    }
                  </div>
                </div>
                <div class="flex pt-6 justify-end">
                  <p-button
                    label="Firmar contrato"
                    iconPos="right"
                    (onClick)="activateCallback(3)"
                  />
                </div>
              </ng-template>
          </p-step-panel>
          <p-step-panel [value]="3">
            <ng-template #content let-activateCallback="activateCallback">
              @if (!signature()) {
                <app-signature
                  (signatureComplete)="onSignatureCompleted($event)"
                />
                } @else {
                <div class="flex flex-col">
                  <div class="flex justify-center">
                    <div
                      class="border-2 border-dashed border-surface rounded-border bg-surface-50 dark:bg-surface-950 flex-col p-2 items-center font-medium"
                    >
                      <img [src]="signature()" />
                    </div>
                  </div>
                  <div class="my-8">
                    <p-checkbox
                      [(ngModel)]="acceptedTos"
                      [binary]="true"
                      inputId="binary"
                    />
                    Acepto el tratamiento de mis datos y procesamiento de mi firma
                    para garantizar la seguridad y legalidad de la misma
                  </div>
                  <div class="flex justify-end gap-2">
                    <p-button
                      size="small"
                      [outlined]="true"
                      severity="danger"
                      label="Repetir firma"
                      (onClick)="resetSignature()"
                    ></p-button>
                    <p-button
                      size="small"
                      label="Firmar operación"
                      [loading]="isProcessing"
                      (onClick)="handleCompleteOperation()"
                      [disabled]="!acceptedTos"
                    ></p-button>
                  </div>
                </div>
                }
            </ng-template>
          </p-step-panel>
        </p-step-panels>
        </p-stepper>
      </div>
    </div>
</div>
